import {Component, OnInit} from '@angular/core';
import {CommonService} from './services/common.service';
declare let WOW: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
   path;
   year = new Date().getFullYear();

   constructor(private common: CommonService) {
   }

   ngOnInit(): void {
      this.path = this.common;
      new WOW().init();
   }
}
